/* eslint-disable react/function-component-definition */
import React from 'react';
import { Link } from 'react-router-dom';

const payrollConfigs = [
  {
    role: 'Cashier',
    base: 18000,
    bonus: 1500,
    tax: 1000,
    total: 18500,
  },
  {
    role: 'Cleaner',
    base: 12000,
    bonus: 0,
    tax: 500,
    total: 11500,
  },
  {
    role: 'Manager',
    base: 30000,
    bonus: 5000,
    tax: 2000,
    total: 33000,
  },
];

const PayrollSettings = () => (
  <div className="p-6 space-y-6">
    <div className="flex flex-wrap justify-center gap-2 md:gap-3 py-2">
      <Link
        to="/hr-dashboard"
        className="px-3 py-2 bg-yellow-900 text-white rounded-lg hover:bg-yellow-600 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">HR Dashboard</span>
      </Link>
      <Link
        to="/attendance-sheet"
        className="px-3 py-2 bg-orange-600 text-white rounded-lg hover:bg-blue-700 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Attendance</span>
      </Link>
      <Link
        to="/payroll"
        className="px-3 py-2 bg-slate-600 text-white rounded-lg hover:bg-blue-700 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Payroll</span>
      </Link>
      <Link
        to="/payroll-monthly"
        className="px-3 py-2 bg-yellow-950 text-white rounded-lg hover:bg-yellow-600 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Monthly Payroll</span>
      </Link>
      <Link
        to="/employee-list"
        className="px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Employees</span>
      </Link>
      <Link
        to="/new-employee"
        className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Add Employee</span>
      </Link>
      <Link
        to="/payroll-settings"
        className="px-3 py-2 bg-cyan-600 text-white rounded-lg hover:bg-gray-700 text-sm md:text-base md:px-4 transition font-medium flex items-center justify-center min-w-[120px]"
      >
        <span className="text-center">Settings</span>
      </Link>
    </div>
    <h2 className="text-2xl font-semibold">Payroll Configuration</h2>
    <div className="bg-white shadow border rounded-xl overflow-auto">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            <th className="text-left px-4 py-2">Role</th>
            <th className="text-left px-4 py-2">Base Salary</th>
            <th className="text-left px-4 py-2">Bonus</th>
            <th className="text-left px-4 py-2">Tax Deduction</th>
            <th className="text-left px-4 py-2">Total Pay</th>
          </tr>
        </thead>
        <tbody>
          {payrollConfigs.map((row) => (
            <tr key={row.role} className="border-t hover:bg-gray-50">
              <td className="px-4 py-2">{row.role}</td>
              <td className="px-4 py-2">
                ৳
                {row.base.toLocaleString()}
              </td>
              <td className="px-4 py-2 text-green-600">
                +৳
                {row.bonus.toLocaleString()}
              </td>
              <td className="px-4 py-2 text-red-500">
                -৳
                {row.tax.toLocaleString()}
              </td>
              <td className="px-4 py-2 font-bold text-blue-600">
                ৳
                {row.total.toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default PayrollSettings;
